// extracted by mini-css-extract-plugin
module.exports = {"fcol":"components-QuestionTemplate-Question-CheckBoxQuestion-CheckboxQuestion__fcol--DkAAZ"};